import { FormDropdownInputComponent } from 'src/features/generalForms/builder/types/DropdownInput';
import { AnswerPreviewRow } from '../previewRow/answerPreviewRow';
import { useCallback } from 'react';
import { useAnswerRowConditional } from 'src/features/generalForms/answerPreview/hooks/useAnswerRowConditional';
import { useAnswerValue } from 'src/features/generalForms/answerPreview/hooks/useAnswerValue';
import { RPDF } from 'src/features/report/react-pdf';

export const FormMultipleDropdownInput: FormDropdownInputComponent = (props) => {
  const value = useAnswerValue(props.dataKey!);
  const renderValue = useCallback(
    (arr: string[]) =>
      props.options
        ?.filter((opt) => arr?.includes(opt.key))
        .map((opt) => opt.value)
        .join(', ') ?? '',
    [props.options],
  );

  const { visible } = useAnswerRowConditional();
  if (!visible) {
    return <RPDF.View />;
  }

  return <AnswerPreviewRow<string[]> value={value} renderValue={renderValue} {...props} />;
};
